import React, { useEffect, useState } from 'react';
import { connect } from "react-redux";

import { editRegisterFee } from '../../../redux/actions/RegisterActions';

import { Panel, PanelBody, PanelHeader } from "../../header/panel/panel"


const FEE_TYPE_OPTIONS = [
    { value: '1', label: 'Cash Back Only' },
    { value: '2', label: 'Total Amount' },
    { value: '3', label: 'Fee Plus' },
    { value: '4', label: 'Tiered' },
]


const RegisterFeeEdit = (props) => {

    const [overrideType, setOverrideType] = useState('')
    const [overrideData, setOverrideData] = useState('')
    const [overrideThreshold, setOverrideThreshold] = useState('')

    const [overrideTypeError, setOverrideTypeError] = useState(false)

    useEffect(() => {
        const fee = props.REGISTERREDUCER.registerFee && props.REGISTERREDUCER.registerFee.length ? props.REGISTERREDUCER.registerFee[0] : null;
        if (fee) {
            setOverrideType(fee.overrideType !== null && fee.overrideType !== undefined ? String(fee.overrideType) : '')
            setOverrideData(fee.overrideData !== null && fee.overrideData !== undefined ? fee.overrideData : '')
            setOverrideThreshold(fee.overrideThreshold !== null && fee.overrideThreshold !== undefined ? fee.overrideThreshold : '')
        }
    }, [props.REGISTERREDUCER.registerFee])

    const handleChange = (event) => {
        let targetName = event.target.name
        let targetValue = event.target.value
        switch (targetName) {
            case 'overrideType':
                setOverrideType(targetValue)
                setOverrideTypeError(false)
                break;
            case 'overrideData':
                setOverrideData(targetValue)
                break;
            case 'overrideThreshold':
                setOverrideThreshold(targetValue)
                break;
            default:
                break;
        }
    }

    const handleSubmit = (event) => {

        event.preventDefault();

        let body = {}

        if (props.REGISTERREDUCER.registerID) {
            body.registerID = props.REGISTERREDUCER.registerID
        }

        if (overrideType) {
            body.overrideType = overrideType
            setOverrideTypeError(false)
        } else {
            setOverrideTypeError(true)
            return
        }

        body.overrideData = overrideData
        body.overrideThreshold = overrideThreshold

        props.editRegisterFee(body)
        props.setShowFeeEditModelOpen(false)
    }

    return (

        <Panel >

            <PanelHeader>EDIT REGISTER FEE - {props.REGISTERREDUCER.registerID}</PanelHeader>

            <PanelBody>

                <form className="fs-13px">

                    <div className="mb-3">

                        <div className="col-md-12 mb-12 mb-md-2">
                            <label className={"col-md-12 " + (overrideTypeError ? 'text-danger' : '')}><b>Fee Type</b></label>
                            <select className="form-select"
                                value={overrideType ? overrideType : ''}
                                onChange={handleChange}
                                name='overrideType'
                            >
                                <option value=''>Select Fee Type</option>
                                {FEE_TYPE_OPTIONS.map((option) => (
                                    <option key={option.value} value={option.value}>
                                        {option.label}
                                    </option>
                                ))}
                            </select>
                        </div>

                        <div className="col-md-12 mb-12 mb-md-2">
                            <label className={"col-md-12"}><b>Fee</b></label>
                            <input type="text" className="form-control fs-13px"
                                value={overrideData !== null && overrideData !== undefined ? overrideData : ''}
                                onChange={handleChange}
                                name='overrideData'
                            />
                        </div>

                        <div className="col-md-12 mb-12 mb-md-2">
                            <label className={"col-md-12"}><b>Fee Threshold</b></label>
                            <input type="text" className="form-control fs-13px"
                                value={overrideThreshold !== null && overrideThreshold !== undefined ? overrideThreshold : ''}
                                onChange={handleChange}
                                name='overrideThreshold'
                            />
                        </div>

                        <div className="col-md-12 mb-12 mb-md-2">
                            <button className='btn btn-primary d-block w-100 btn-lg h-9px fs-13px' onClick={handleSubmit}>{'Save'}</button>
                        </div>

                    </div>
                </form>

            </PanelBody >

        </Panel >

    )
}

function mapStateToProps(state) {
    return state
}

const mapDispatchToProps = {
    editRegisterFee
}


export default connect(mapStateToProps, mapDispatchToProps)(RegisterFeeEdit);
